import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem, Popover, OverlayTrigger } from 'react-bootstrap';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Overlay from '../Miscelania/Overlay';

// Tabs
import AircraftLogbookFuelCheckTab from './Elements/AircraftLogbookFuelCheckTab';
import AircraftLogbookBFFInspectionTab from './Elements/AircraftLogbookBFFInspectionTab';
import AircraftLogbookMaintenanceOperationalRestrictionTab from './Elements/AircraftLogbookMaintenanceOperationalRestrictionTab';
import AircraftLogbookAirworthinessReleaseTab from './Elements/AircraftLogbookAirworthinessReleaseTab';
import AircraftLogbookCrewTab from './Elements/AircraftLogbookCrewTab';
import AircraftLogbookFlightsTab from './Elements/AircraftLogbookFlightsTab';
import AircraftLogbookFlightAdditionalItensTab from './Elements/AircraftLogbookFlightAdditionalItensTab';
import AircraftLogbookTotalsTab from './Elements/AircraftLogbookTotalsTab';
import AircraftLogbookEngineSpecialCountersTab from './Elements/AircraftLogbookEngineSpecialCountersTab';
import AircraftLogbookEquipmentSpecialCountersTab from './Elements/AircraftLogbookEquipmentSpecialCountersTab';
import AircraftLogbookFluidsRefilTab from './Elements/AircraftLogbookFluidsRefilTab';
import AircraftLogbookPowerCheckTab from './Elements/AircraftLogbookPowerCheckTab';
import AircraftLogbookALFInspectionTab from './Elements/AircraftLogbookALFInspectionTab';
import AircraftLogbookOccurrencesTab from './Elements/AircraftLogbookOccurrencesTab';
import AircraftLogbookNoDiscrepanciesTab from './Elements/AircraftLogbookNoDiscrepanciesTab';
import AircraftLogbookReportsTab from './Elements/AircraftLogbookReportsTab';
import AircraftLogbookReportActionsTab from './Elements/AircraftLogbookReportActionsTab';
import AircraftLogbookLogsTab from './Elements/AircraftLogbookLogsTab';
import LogbookSignatureModal from '../LogbookAppIntegration/LogbookSignatureModal';

class AircraftLogbookEdit extends Component {

    constructor(props) {
      super(props);
  
      this.state = {
        overlay: {
          message: '',
          type: '',
          status: 'open',
        },
        redirect_url: false,
        loaded: 0,
        updated: 0,
        report_trash: 0,
        id: '',
        logbook_app: '',
        logbook_app_status: {},
        validation_overview: {},
        logbook_app_status_sync_error: null,
        aircraft_id: '',
        date: '',
        date_str: '',
        status: '',
        status_str: '',
        correlation_analysis: '',
        correlation_analysis_str: '',
        limit_date: '',
        limit_date_str: '',
        registration: '',
        serial_number: '',
        ca: '',
        iam: '',
        aircraft_model: '',
        engine_1_id: '',
        engine_2_id: '',
        aircraft: {},
        engines_list: [],
        approvals: [],
        approvals_reports: [],
        inspections: '',
        airworthiness_releases: '',
        staffs: {},
        flights: {},
        aircraft_model_version_custom_items: {},
        flight_reports_list: [],
        flight_legs_list: [],
        hums_flight_report_legs: [],
        transit_inspections_flight_report_legs: [],
        totals: '',
        special_counters: [],
        fluids_refils: {},
        power_checks: {},
        occurrences: {},
        reports: {},
        aircraft_logbook_logs: {},
        fuel_check_ok: false,
        fuel_check_na: false,
        aircraft_logbook_reports_list: [],
        aircraft_logbook_deferred_items: {},
        report_actions: {},
        pending_captain_acceptances: [],
        report_action_parts_replacements: [],
        report_action_deferred_items: [],
        aircraft_models_list: [],
        maintenance_intervention_types_list: [],
        flight_type_list: [],
        locations_list: [],
        civil_qualification_types_list: [],
        fluids_refills_list: [],
        systems_list: [],
        abnormal_occurrence_types_select: [],
        users_list: [],
        maintenance_operational_restriction_list: [],
        bases_list: [],
        errors_messages: [],
        errors_listing: false,
        showLogbookSignatureModal: false,
        logbookSignaturePurpose: null,
        pendingSignaturePayload: null,
        validation_overview_open: true,
        logbook_app_url: '',
      };
      //Handlers
      this.handleAlert = this.handleAlert.bind(this);
      this.handleLoaded = this.handleLoaded.bind(this);
      this.handleMessage = this.handleMessage.bind(this);
      this.popover = this.popover.bind(this);
  
      this.updateData = this.updateData.bind(this);
      this.loadData = this.loadData.bind(this);
      this.edit = this.edit.bind(this);
      this.editEngines = this.editEngines.bind(this);
      this.statusOptions = this.statusOptions.bind(this);
      this.changeStatus = this.changeStatus.bind(this);
      this.approve = this.approve.bind(this);
      this.approveDeferredItem = this.approveDeferredItem.bind(this);
      this.openLogbookAppAction = this.openLogbookAppAction.bind(this);
      this.handleLogbookSignatureModalSubmit = this.handleLogbookSignatureModalSubmit.bind(this);
      this.closeLogbookSignatureModal = this.closeLogbookSignatureModal.bind(this);
      this.executeLogbookAppAction = this.executeLogbookAppAction.bind(this);
      this.executeApprovalRequest = this.executeApprovalRequest.bind(this);
      this.requiresLogbookAppReopen = this.requiresLogbookAppReopen.bind(this);
      this.getSignatureModalProps = this.getSignatureModalProps.bind(this);
      this.toggleValidationOverview = this.toggleValidationOverview.bind(this);
      this.renderGuidancePanel = this.renderGuidancePanel.bind(this);
    }

    // Handlers
    handleChange (name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  
    handleSelectChange(name, event) {
      var change = {};
      if(event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  
    handleAlert(message, type, status, mode) {
      if(mode === 'reset') {
        this.setState({overlay: {message: '', type: '', status: 'closed'}});
      } else {
        this.setState({overlay: {message: message, type: type, status: status}});
      }
    }
  
    handleLoaded(state) {
      if(this.state.loaded !== 2) {
        this.setState({loaded: state});
      }
    }
  
    handleMessage () {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
        localStorage.removeItem("verify_message");
      }
    }

    popover (title, boldText) {
      const regularTexts = Array.from(arguments).slice(1);
      return (
        <Popover id="popover-positioned-top" title={title}>
          {boldText != null && <strong>{boldText}</strong>}
          {boldText != null && <br/>}
          {regularTexts.map((text, i) => (
            <span key={i}>
              {i > 1 && <br/>}
              {text}
            </span>
          ))}
        </Popover>
      );
    }
  
    componentDidMount () {
      this.refs.request_api.header();
    }
  
    componentDidUpdate(prevProps, prevState) {
      if(this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({loaded: 2}, this.loadData());
      }
    }

    updateData (responseJson) {
      this.setState({updated: 1}, this.loadData(responseJson));
    }
  
    loadData (event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/aeronave/diario/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url', '/aeronaves/diarios');
          if (responseJson.status === 'success') {
            self.setState({
              logbook_app: responseJson.data.logbook_app,
              logbook_app_status: responseJson.data.logbook_app_status || {},
              logbook_app_status_sync_error: event && event.data ? event.data.status_sync_error : null,
              logbook_app_url: responseJson.data.logbook_app_url || self.state.logbook_app_url,
              validation_overview: responseJson.data.validation_overview || {},
              id: responseJson.data.main.id,
              aircraft_id: responseJson.data.main.aircraft_id,
              report_trash: responseJson.data.main.report_trash,
              aircraft: responseJson.data.main.aircraft,
              engine_1_id: responseJson.data.main.engine_1_id,
              engine_2_id: responseJson.data.main.engine_2_id,
              date: responseJson.data.main.date,
              date_str: responseJson.data.main.date_str,
              status: responseJson.data.main.status,
              status_str: responseJson.data.main.status_str,
              correlation_analysis: responseJson.data.main.correlation_analysis,
              correlation_analysis_str: responseJson.data.main.correlation_analysis_str,
              overload_analysis: responseJson.data.main.overload_analysis,
              overload_analysis_str: responseJson.data.main.overload_analysis_str,
              limit_date: responseJson.data.main.limit_date,
              limit_date_str: responseJson.data.main.limit_date_str,
              registration: responseJson.data.main.registration,
              aircraft_model: responseJson.data.main.aircraft_model,
              serial_number: responseJson.data.main.serial_number,
              ca: responseJson.data.main.ca,
              iam: responseJson.data.main.iam,
              fuel_check_ok: responseJson.data.main.fuel_check_ok,
              fuel_check_na: responseJson.data.main.fuel_check_na,
              engines_list: responseJson.data.engines_list,
              approvals: responseJson.data.approvals,
              approvals_reports: responseJson.data.approvals_reports,
              inspections: responseJson.data.inspections,
              airworthiness_releases: responseJson.data.airworthiness_releases,
              staffs: responseJson.data.staffs,
              flights: responseJson.data.flights,
              aircraft_model_version_custom_items: responseJson.data.aircraft_model_version_custom_items,
              flight_reports_list: responseJson.data.flight_reports_list,
              flight_legs_list: responseJson.data.flight_legs_list,
              fluids_refills_list: responseJson.data.fluids_refills_list,
              hums_flight_report_legs: responseJson.data.hums_flight_report_legs,
              transit_inspections_flight_report_legs: responseJson.data.transit_inspections_flight_report_legs,
              totals: responseJson.data.totals,
              special_counters: responseJson.data.special_counters,
              fluids_refils: responseJson.data.fluids_refils,
              power_checks: responseJson.data.power_checks,
              occurrences: responseJson.data.occurrences,
              abnormal_occurrence_types_select: responseJson.data.abnormal_occurrence_types_select,
              users_list: responseJson.data.users_list,
              bases_list: responseJson.data.bases_list,
              reports: responseJson.data.reports,
              aircraft_logbook_logs: responseJson.data.aircraft_logbook_logs,
              aircraft_logbook_reports_list: responseJson.data.aircraft_logbook_reports_list,
              maintenance_operational_restriction_list: responseJson.data.maintenance_operational_restriction_list,
              systems_list: responseJson.data.systems_list,
              aircraft_logbook_deferred_items: responseJson.data.aircraft_logbook_deferred_items,
              report_actions: responseJson.data.report_actions,
              pending_captain_acceptances: responseJson.data.pending_captain_acceptances,
              report_action_parts_replacements: responseJson.data.report_action_parts_replacements,
              report_action_deferred_items: responseJson.data.report_action_deferred_items,
              maintenance_intervention_types_list: responseJson.data.maintenance_intervention_types_list,
              flight_type_list: responseJson.data.flight_type_list,
              locations_list: responseJson.data.locations_list,
              civil_qualification_types_list: responseJson.data.civil_qualification_types_list,
            });
          }
        }).then(() => {
          var url = config.get('api') + '/aeronave/modelo/lista';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({aircraft_models_list: responseJson.data});
            }
        }).then(() => {
          if (event) {
            self.handleAlert(event.message, event.status, 'open');
          } else {
            self.setState({overlay: {message: '', type: '', status: 'closed'}});
            self.handleMessage();
          }
        }); });
      });
    }

    //Salvar ou atualizar motores
    editEngines(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var url = '/aeronave/diario/motores';
      var data = {
        id: this.state.id,
        engine_1_id: this.state.engine_1_id,
        engine_2_id: this.state.engine_2_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(data) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.updateData(responseJson);
            self.setState({overlay: {message: responseJson.message, type: 'success', status: 'open'}});
          } else {
            self.setState({overlay: {message: responseJson.message, type: 'error', status: 'open'}});
          }
        });
      });
    }
  
    // Fetch salvando a edição
    edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        aircraft_id: this.state.aircraft_id,
        date: this.state.date,
        status: this.state.status,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/diario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }

    statusOptions() {
      switch (this.state.status) {
        // Se o status for "Em andamento"
        case 0:
          return (
            <Dropdown id="revisions">
              <Dropdown.Toggle bsStyle={'primary'}>
                <i className="fa fa-fw fa-certificate"></i> {this.state.status_str}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={this.changeStatus} eventKey={1}>Trocar para Finalizado</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          );
        // Se o status for "Finalizado"
        case 1:
          return (
            <Dropdown id="revisions">
              <Dropdown.Toggle bsStyle={'primary'}>
                <i className="fa fa-fw fa-certificate"></i> {this.state.status_str}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={this.changeStatus} eventKey={0}>Retornar para Em Andamento</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          );
      }
    }

    changeStatus(status) {
      var confirm = "Tem certeza que gostaria de trocar o status do diário de bordo?";
      if (window.confirm(confirm)) {
        var datasave = {
          id: this.props.match.params.id,
          status: status,
        };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/aeronave/diario/status';
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
            if(responseJson.status === 'warning') {
              self.setState({
                errors_listing: true,
                errors_messages: responseJson.data,
              });
            } else {
              self.setState({
                errors_listing: false,
                errors_messages: [],
              });
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }

    openLogbookAppAction(action) {
      if (action === 'approve') {
        var finalizeConfirm = 'Isso deve ser feito apenas ao final da jornada. Tem certeza que deseja continuar?';
        if (!window.confirm(finalizeConfirm)) {
          return;
        }
      }

      this.setState({
        showLogbookSignatureModal: true,
        logbookSignaturePurpose: 'logbook_app_action',
        pendingSignaturePayload: { action: action }
      });
    }

    closeLogbookSignatureModal() {
      this.setState({
        showLogbookSignatureModal: false,
        logbookSignaturePurpose: null,
        pendingSignaturePayload: null
      });
    }

    requiresLogbookAppReopen() {
      return this.state.logbook_app === 1 && this.state.logbook_app_status && this.state.logbook_app_status.is_approved === true;
    }

    toggleValidationOverview() {
      this.setState({ validation_overview_open: !this.state.validation_overview_open });
    }

    handleLogbookSignatureModalSubmit(credentials) {
      const purpose = this.state.logbookSignaturePurpose;
      const payload = this.state.pendingSignaturePayload;
      this.setState({ showLogbookSignatureModal: false }, () => {
        if (purpose === 'logbook_app_action' && payload) {
          this.executeLogbookAppAction(payload.action, credentials);
        }

        if (purpose === 'airworthiness_release' && payload) {
          this.executeApprovalRequest(payload, credentials);
        }
      });
    }

    executeLogbookAppAction(action, credentials) {
      this.setState({ pendingSignaturePayload: null, logbookSignaturePurpose: null });
      const endpoint = action === 'reopen' ? '/integrar/logbook/data/reabrir' : '/integrar/logbook/data/aprovar';
      const datasave = {
        aircraft_logbook_id: this.props.match.params.id,
        email: credentials.email,
        password: credentials.password,
      };

      this.handleAlert('', '', 'open');
      const header = this.refs.request_api.header('application/json');
      const self = this;

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + endpoint, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) })
          .then((response) => response.json())
          .catch((error) => { console.error(error); })
          .then((responseJson) => {
            if (responseJson && responseJson.status === 'success') {
              self.refs.request_api.validate(responseJson, 'alert');
              self.updateData(responseJson);
            } else if (responseJson) {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          })
          .catch((error) => { console.error(error); });
      });
    }

    executeApprovalRequest(approvalData, credentials) {
      this.setState({ pendingSignaturePayload: null, logbookSignaturePurpose: null });
      var datasave = {
        id: approvalData.id,
        type: approvalData.type,
      };

      if (credentials) {
        datasave.email = credentials.email;
        datasave.password = credentials.password;
      }

      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = '/aeronave/diario/aprovacao/aprovar';
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if(responseJson.status === 'success') {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }

    getSignatureModalProps() {
      const purpose = this.state.logbookSignaturePurpose;
      const isApproved = this.state.logbook_app_status && this.state.logbook_app_status.is_approved;

      if (purpose === 'logbook_app_action') {
        return {
          title: isApproved ? 'Reabrir data no Logbook App' : 'Aprovar data no Logbook App',
          subtitle: 'Informe suas credenciais do Logbook App para continuar.',
          confirmation: isApproved ? 'Confirmar reabertura' : 'Confirmar aprovação',
        };
      }

      if (purpose === 'airworthiness_release') {
        return {
          title: 'Reabrir data no Logbook App',
          subtitle: 'Antes de aprovar a liberação de aeronavegabilidade, precisamos reabrir a data no Logbook App usando sua assinatura.',
          confirmation: 'Reabrir e prosseguir',
        };
      }

      return {
        title: 'Informe suas credenciais do Logbook App',
        subtitle: 'As credenciais são necessárias para concluir esta ação no Logbook App.',
        confirmation: 'Confirmar',
      };
    }

    renderGuidancePanel() {
      return (
        <div className="panel panel-default" style={{ marginTop: 15 }}>
          <div className="panel-heading"><strong>Orientações rápidas</strong></div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-6">
                <h5 className="text-uppercase">Tripulação</h5>
                <ul className="list-unstyled" style={{ marginBottom: 0 }}>
                  <li><i className="fa fa-check text-primary"></i> Após revisar o diário, utilize o botão verde de Aceitação do Comandante.</li>
                  <li><i className="fa fa-check text-primary"></i> Na análise de ACR, confirme a sobrecarga antes de enviar para manutenção.</li>
                  <li><i className="fa fa-check text-primary"></i> Registre reportes quando houver discrepância e aprove-os para bloquear novos voos até a resposta.</li>
                  <li><i className="fa fa-check text-primary"></i> No final da jornada, <strong>finalize</strong> o Logbook App.</li>
                </ul>
              </div>
              <div className="col-md-6">
                <h5 className="text-uppercase">Manutenção</h5>
                <ul className="list-unstyled" style={{ marginBottom: 0 }}>
                  <li><i className="fa fa-wrench text-danger"></i> Preencha e confirme a liberação de aeronavegabilidade; sem ela, relatórios de voo não podem ser finalizados.</li>
                  <li><i className="fa fa-wrench text-danger"></i> Confirme inspeções de HUMS e de trânsito.</li>
                  <li><i className="fa fa-wrench text-danger"></i> Responda aos reportes com ações de manutenção e aprove o RTS correspondente.
                  </li>
                  <li><i className="fa fa-wrench text-danger"></i> Registre postergações e substituições de componentes.</li>
                  <li><i className="fa fa-wrench text-danger"></i> Se houver a necessidade de nova liberação de aeronavegabilidade crie uma nova página de diário de bordo.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    }

    approve(id, type) {
      var confirm = "Tem certeza que deseja aprovar?";
      if(window.confirm(confirm)) {
        if (type === 3 && this.requiresLogbookAppReopen()) {
          this.setState({
            showLogbookSignatureModal: true,
            logbookSignaturePurpose: 'airworthiness_release',
            pendingSignaturePayload: { id: id, type: type }
          });
          return;
        }

        this.executeApprovalRequest({ id: id, type: type });
      }
    }

    approveDeferredItem(id, overload_analysis) {
      var confirm = "Tem certeza que deseja continuar?";
      if(window.confirm(confirm)) {
        var datasave = {
          id: id,
          overload_analysis: overload_analysis,
        };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/aeronave/diario/item/acao/adiada/aprovar';
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if(responseJson.status === 'success'){
              self.refs.request_api.validate(responseJson, 'alert');
              self.updateData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }
  
    render() {
      var self = this;
      const signatureModalProps = this.getSignatureModalProps();
      return (
  <div>
    <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
    <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
    <div className="container-fluid">
      <div className="conteudo">
        <h3 className="page-title pull-left">Editar Diário de Bordo</h3>
        <div className="clearfix"></div>
        <h4 className="page-title pull-left">Aeronave: {this.state.registration} | Data: {this.state.date_str}</h4>
        <div className="grid-buttons pull-right">
          {this.statusOptions()}
          <Link to="/aeronave/diarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
        </div>
        <div className="clearfix"></div>
        {this.renderGuidancePanel()}
        {this.state.logbook_app == 1 &&
          <div className="panel panel-default" style={{ marginTop: 20 }}>
            <div className="panel-heading clearfix">
              <strong>
                <a href={this.state.logbook_app_url || '#'} target="_blank" rel="noopener noreferrer">
                  Logbook App
                </a>
              </strong>
            </div>
            <div className="panel-body">
              <div className="alert alert-danger" role="alert">
                <span className="fa fa-warning"></span> <strong>Atenção:</strong> O Logbook App só deverá ser finalizado após o término da jornada! Após a finalização, o sistema impedirá qualquer alteração no diário de bordo.
              </div>
              <div className="row">
                <div className="col-md-4">
                  <label>Status</label>
                  <p>
                    <span className={'label ' + (this.state.logbook_app_status.is_approved ? 'label-success' : 'label-warning')}>
                      {this.state.logbook_app_status.status_label || 'Pendente'}
                    </span>
                  </p>
                  {this.state.logbook_app_status.synced_at &&
                    <small>Atualizado em {this.state.logbook_app_status.synced_at}</small>
                  }
                  {this.state.logbook_app_status.signature_status &&
                    <div><small>Assinatura: {this.state.logbook_app_status.signature_status}</small></div>
                  }
                </div>
                <div className="col-md-4">
                  <label>Ações</label>
                  <div>
                    {this.state.logbook_app_status.is_approved ?
                      <button type="button" className="btn btn-danger" onClick={() => this.openLogbookAppAction('reopen')}>
                        <i className="fa fa-undo"></i> Reabrir Logbook App
                      </button>
                      :
                      <button type="button" className="btn btn-primary" onClick={() => this.openLogbookAppAction('approve')}>
                        <i className="fa fa-check"></i> Finalizar Logbook App
                      </button>
                    }
                  </div>
                </div>
                <div className="col-md-4">
                  <label>Aprovado em</label>
                  <p>{this.state.logbook_app_status.approval_date || '-'}</p>
                </div>
              </div>
              {this.state.logbook_app_status_sync_error &&
                <div className="alert alert-warning" style={{ marginTop: 15 }}>
                  {this.state.logbook_app_status_sync_error}
                </div>
              }
            </div>
          </div>
        }
        {Object.keys(this.state.validation_overview || {}).length > 0 &&
          <div className="panel panel-info" style={{ marginTop: 15 }}>
            <div className="panel-heading clearfix">
              <strong>Checklist de pendências</strong>
              <button
                type="button"
                className="btn btn-link btn-xs pull-right"
                onClick={this.toggleValidationOverview}
                style={{ marginTop: -3 }}
              >
                <i className={'fa ' + (this.state.validation_overview_open ? 'fa-chevron-down' : 'fa-chevron-up')}></i>
              </button>
            </div>
            {this.state.validation_overview_open &&
              <div className="panel-body">
                {['finalize', 'add_same_day', 'add_next_day'].map((key) => {
                  const item = this.state.validation_overview[key];
                  if (!item) {
                    return null;
                  }

                  const hasErrors = Array.isArray(item.errors) && item.errors.length > 0;

                  return (
                    <div key={key} style={{ marginBottom: 15 }}>
                      <strong>{item.label || ''}{item.date ? ' — ' + item.date : ''}</strong>
                      {hasErrors ? (
                        <ul className="list-unstyled" style={{ marginTop: 10 }}>
                          {item.errors.map((message, index) => (
                            <li key={index}>
                              <i className="fa fa-exclamation-circle text-danger"></i> {message}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p style={{ marginTop: 10 }}>
                          <i className="fa fa-check text-success"></i> Nenhuma pendência identificada.
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            }
          </div>
        }
        {this.state.errors_listing &&
          <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
            <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <strong>Os seguintes erros de preenchimento impediram o diário de bordo de ser finalizado:</strong>
            {Object.keys(self.state.errors_messages).map(function(k) {
              var message = self.state.errors_messages[k];
              return (
                <p>- {message}</p>
              );
            })}
          </div>
        }
        <hr/>
        <form onSubmit={this.edit}>
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label>Manufacturer/Model:</label>
                <input type="text" name="aircraft_model" className="form-control" placeholder="Modelo da aeronave" value={this.state.aircraft_model} onChange={this.handleChange.bind(this, 'aircraft_model')} disabled />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>Tail Number:</label>
                <input type="text" name="registration" className="form-control" placeholder="Registro da aeronave" value={this.state.registration} onChange={this.handleChange.bind(this, 'registration')} disabled />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>CAT:</label>
                <input type="text" name="operation_type_id" className="form-control" placeholder="Categoria da aeronave" value={this.state.operation_type_id} onChange={this.handleChange.bind(this, 'operation_type_id')} disabled />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>S/N:</label>
                <input type="text" name="serial_number" className="form-control" placeholder="Número de série" value={this.state.serial_number} onChange={this.handleChange.bind(this, 'serial_number')} disabled />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>C.A.:</label>
                <input type="text" name="ca" className="form-control" placeholder="Vencimento do CA" value={this.state.ca} onChange={this.handleChange.bind(this, 'ca')} disabled />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>I.A.M:</label>
                <input type="text" name="iam" className="form-control" placeholder="Vencimento do IAM" value={this.state.iam} onChange={this.handleChange.bind(this, 'iam')} disabled />
              </div>
            </div>
          </div>
        </form>
        <div className="clearfix"></div>
        <hr/>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Engine #1:</label>
              <Select
                className="form-group"
                name="engine_1_id"
                value={this.state.engine_1_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'engine_1_id')}
                options={this.state.engines_list}
                disabled
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Engine #2:</label>
              <Select
                className="form-group"
                name="engine_2_id"
                value={this.state.engine_2_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'engine_2_id')}
                options={this.state.engines_list}
                disabled
              />
            </div>
          </div>
        </div>
        <hr/>
        <div className='overlay'>
          <AircraftLogbookFuelCheckTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} fuel_check_ok={this.state.fuel_check_ok} fuel_check_na={this.state.fuel_check_na} />
          <hr/>
          <AircraftLogbookBFFInspectionTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} inspections={this.state.inspections} />
          <hr/>
        </div>
        <AircraftLogbookMaintenanceOperationalRestrictionTab updated={this.state.updated} handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approveDeferredItem={this.approveDeferredItem} aircraft_logbook_deferred_items={this.state.aircraft_logbook_deferred_items} status_str={this.state.status_str} overload_analysis_str={this.state.overload_analysis_str} correlation_analysis_str={this.state.correlation_analysis_str} limit_date_str={this.state.limit_date_str} />
        <div className='overlay'>
          <AircraftLogbookAirworthinessReleaseTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} airworthiness_releases={this.state.airworthiness_releases} maintenance_intervention_types_list={this.state.maintenance_intervention_types_list} flight_type_list={this.state.flight_type_list} logbook_app={this.state.logbook_app} />
        </div>
        <AircraftLogbookCrewTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} staffs={this.state.staffs} pending_captain_acceptances={this.state.pending_captain_acceptances} logbook_app={this.state.logbook_app} />
        <hr/>
        <AircraftLogbookFlightsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} flights={this.state.flights} aircraft_model_version_custom_items={this.state.aircraft_model_version_custom_items} flight_reports_list={this.state.flight_reports_list} aircraft={this.state.aircraft} />
        <hr/>
        <div className='overlay'>
          <AircraftLogbookFlightAdditionalItensTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} hums_flight_report_legs={this.state.hums_flight_report_legs} transit_inspections_flight_report_legs={this.state.transit_inspections_flight_report_legs} />
          <hr/>
        </div>
        <AircraftLogbookTotalsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} totals={this.state.totals} />
        <hr/>
        <AircraftLogbookEngineSpecialCountersTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} special_counters={this.state.special_counters} />
        <hr/>
        <AircraftLogbookEquipmentSpecialCountersTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} special_counters={this.state.special_counters} />
        <hr/>
        <AircraftLogbookPowerCheckTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} power_checks={this.state.power_checks} flight_legs_list={this.state.flight_legs_list} />
        <hr/>
        <AircraftLogbookOccurrencesTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} occurrences={this.state.occurrences} flight_legs_list={this.state.flight_legs_list} abnormal_occurrence_types_select={this.state.abnormal_occurrence_types_select} locations_list={this.state.locations_list} civil_qualification_types_list={this.state.civil_qualification_types_list} logbook_app={this.state.logbook_app} />
        <hr/>
        <div className='overlay'>
          <AircraftLogbookFluidsRefilTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} fluids_refils={this.state.fluids_refils} flight_legs_list={this.state.flight_legs_list} fluids_refills_list={this.state.fluids_refills_list} />
          <hr/>
          <AircraftLogbookALFInspectionTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals={this.state.approvals} approve={this.approve} inspections={this.state.inspections} />
          <hr/>
        </div>
        <AircraftLogbookNoDiscrepanciesTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} aircraft_logbook_id={this.props.match.params.id} />
        <hr/>
        <AircraftLogbookReportsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} report_trash={this.state.report_trash} approvals={this.state.approvals} approve={this.approve} flight_legs_list={this.state.flight_legs_list} reports={this.state.reports} users_list={this.state.users_list} maintenance_intervention_types_list={this.state.maintenance_intervention_types_list} fluids_refills_list={this.state.fluids_refills_list} bases_list={this.state.bases_list} locations_list={this.state.locations_list} logbook_app={this.state.logbook_app} />
        <hr/>
        <div className='overlay'>
          <AircraftLogbookReportActionsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.props.match.params.id} approvals_reports={this.state.approvals_reports} approve={this.approve} aircraft_logbook_reports_list={this.state.aircraft_logbook_reports_list} reports={this.state.reports} report_actions={this.state.report_actions} report_action_parts_replacements={this.state.report_action_parts_replacements} report_action_deferred_items={this.state.report_action_deferred_items} users_list={this.state.users_list} bases_list={this.state.bases_list} maintenance_operational_restriction_list={this.state.maintenance_operational_restriction_list} systems_list={this.state.systems_list} engines_list={this.state.engines_list} fluids_refills_list={this.state.fluids_refills_list} maintenance_intervention_types_list={this.state.maintenance_intervention_types_list} airworthiness_releases={this.state.airworthiness_releases} logbook_app={this.state.logbook_app} />
          <hr/>
        </div>
        <AircraftLogbookLogsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} aircraft_logbook_id={this.props.match.params.id} aircraft_logbook_logs={this.state.aircraft_logbook_logs} />
        <hr/>
      </div>
    </div>
    <LogbookSignatureModal
      show={this.state.showLogbookSignatureModal}
      onHide={this.closeLogbookSignatureModal}
      onSubmit={this.handleLogbookSignatureModalSubmit}
      {...signatureModalProps}
    />
  </div>
      );
    }
}

export default AircraftLogbookEdit;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/AircraftLogbooksEdit.js